<script lang="ts" setup>
import { globalCssVariables } from 'monocle-components/internal'
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
